import { IViewConfiguration } from "@formant/core/model/IViewConfiguration";
import { IViewConfigurationMap } from "@formant/core/model/IViewConfigurationMap";
import { StreamType } from "@formant/core/model/StreamType";

import { findConfiguration } from "./findConfiguration";

export function updateConfiguration<T extends StreamType>(
    configuration: IViewConfiguration[],
    streamName: string,
    type: T,
    updates: T extends keyof IViewConfigurationMap
        ? Partial<IViewConfigurationMap[T]>
        : never,
): IViewConfiguration[] {
    const existing = findConfiguration(configuration, streamName, type);

    return [
        ...configuration.filter(
            _ => _.streamName !== streamName || _.type !== type,
        ),
        {
            streamName,
            type,
            configuration: {
                ...existing,
                ...updates,
            },
        },
    ];
}
